import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicationInfosResponse } from '../types'

type AcceptApplicationPayload = {
  applicantOrderStatus?: string
  note?: string
}

export const useAcceptApplication = ({ orderId }: { orderId?: number }) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      applicationId,
      orderStatus,
      note
    }: {
      applicationId: number
      orderStatus?: number
      note?: string
      skipInvalidation?: boolean
    }) => {
      const payload: AcceptApplicationPayload = {}
      if (orderStatus !== undefined) {
        payload.applicantOrderStatus = `/v1/taxonomies/applicant_order_statuses/${orderStatus}`
      }
      if (note !== undefined) {
        payload.note = note
      }

      return await fetchApiWithToken<ApplicationInfosResponse>({
        method: 'post',
        url: `/v1/applications/${applicationId}/accept`,
        data: payload
      })
    },
    onSuccess: (data, variables) => {
      if (variables.skipInvalidation) {
        return
      }

      queryClient.setQueryData(['applications', variables.applicationId], data)

      queryClient.invalidateQueries({
        queryKey: ['applications']
      })

      if (orderId) {
        queryClient.invalidateQueries({
          queryKey: ['order', orderId]
        })
      }

      queryClient.invalidateQueries({
        queryKey: ['orders']
      })
    }
  })
}
